import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/order/reassign/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 改派
export function orderReassign(data) {
  return request.send({
    url: `/pmy/freight/order/reassign`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
export function detailInfo(orderId) {
  return request.send({
    url: `/pmy/freight/order/freight/info?orderId=${orderId}`,
    method: "get",
  });
}
// 撤销审批
export function rollbackReassign(reassignId) {
  return request.send({
    url: `/pmy/freight/order/reassign/rollback?reassignId=${reassignId}`,
    method: "delete",
  });
}
